import { MessageTemplateDto } from '../Types/MessageT';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';

const BASE_URL = process.env.REACT_APP_MESSAGE_SERVICE_URL;

const fetchTemplates = async (): Promise<MessageTemplateDto[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/email/template`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const fetchTemplate = async (id: number): Promise<MessageTemplateDto | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/email/template/id/${id}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const exportEvent = async (
  eventId: number,
  receiverContactId: number,
  recommendationId: string,
  data: Record<string, unknown>,
): Promise<boolean> => {
  const res = await ajaxActions.put(
    `${BASE_URL}/export/events/${eventId}?receiverContactId=${receiverContactId}&embedCustomerDetails=${true}`,
    {
      id: recommendationId,
      ...data,
    },
  );
  if (res.ok) {
    ToastS.success('send.event.info', 'Event-Daten per Mail verschickt');
    return true;
  }
  ToastS.generalError();
  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const MessageS = {
  exportEvent,
  fetchTemplate,
  fetchTemplates,
};
